export const protectedInstructionPaths = Object.freeze([
    "/service/edo",
    "/service/notifications",
    "/service/time-windows",
    "/service/legal-entity-disagreement",
    "/service/vehicle-inspection",
    "/service/vat",
    "/service/partners",
    "/service/contract-termination",
    "/service/goslog-vital-approval",
    "/service/bid-submission",
]);

export function isProtectedInstructionPath(pathname) {
    return protectedInstructionPaths.some(
        (instructionPath) => (
            pathname === instructionPath ||
            pathname.startsWith(
                `${instructionPath}/`
            )
        )
    );
}

export function shouldBlurInstruction({
    pathname,
    isAuthenticated,
}) {
    return (
        !isAuthenticated &&
        isProtectedInstructionPath(pathname)
    );
}
